export default __webpack_public_path__ + "static/media/PaperPlane.e2b0170f.png";